import { useEffect } from 'react';

// Setting overflow:hidden on <html> is required for iOS Safari — body alone is ignored.
// overscroll-behavior:none prevents rubber-band scrolling on iOS 16+.
export function useBodyScrollLock(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    const html = document.documentElement;
    const body = document.body;

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';

    return () => {
      html.style.overflow = '';
      html.style.overscrollBehavior = '';
      body.style.overflow = '';
    };
  }, [enabled]);
}
